if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"],
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.items;
      this.notes = Array.from(this.querySelectorAll("[data-tab-note]"));
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderEnabled) {
        for (let block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
          document.addEventListener("matchMobile", () => {
            this.initSliderByScreenSize(block);
          });
          document.addEventListener("unmatchMobile", () => {
            this.initSliderByScreenSize(block);
          });
        }
      }
      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileSliderDisable &&
        this.buttonType === "load"
      ) {
        this.canLoad = true;
        this.currentPage = 1;
        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      document.addEventListener("matchMobile", () => {
        if (
          MinimogTheme.config.mqlMobile &&
          this.mobileSliderDisable &&
          this.buttonType === "load"
        ) {
          this.canLoad = true;
          this.currentPage = 1;
          for (let block of this.domNodes.tabContent) {
            this.initLoadMore(block);
          }
        }
      });
      this.initTabs();
      this.initMobileSelect();
      this.initHeaderNav();
      this.syncNotes(0);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabBlock =
            event.target &&
            (event.target.classList.contains("m-tab-content")
              ? event.target
              : event.target.closest && event.target.closest(".m-tab-content"));
          if (!tabBlock) return;
          const dataIndex = tabBlock.dataset.index;
          if (dataIndex != null) {
            this.tabs.setActiveTab(parseInt(dataIndex));
            this.syncNotes(dataIndex);
            this.syncHeader();
          }
        });
      }
    }

    // Each tab can carry its own info line (block setting "Descrição / Características do tecido");
    // only the one belonging to the active tab is shown.
    syncNotes(index) {
      if (!this.notes.length || index == null) return;
      const activeIndex = String(index);
      let anyActive = false;
      this.notes.forEach((note) => {
        const isActive = note.dataset.index === activeIndex;
        note.classList.toggle("active", isActive);
        if (isActive) anyActive = true;
      });
      const notesContainer = this.querySelector(".m-product-tabs__notes");
      if (notesContainer) {
        notesContainer.style.display = anyActive ? "" : "none";
      }
    }

    // "Ver tudo" e as setas ficam no topo da secao, fora das abas, entao
    // acompanham a aba ativa: o link vai para a colecao dela e as setas movem
    // o carrossel dela.
    initHeaderNav() {
      this.headerActions = MinimogTheme.initCarouselHeaderActions(this, () => {
        const tab = this.tabs && this.tabs.currentTab;
        const wrapper = tab && tab.querySelector(".m-mixed-layout__wrapper");
        return wrapper && wrapper.swiper;
      });
    }

    // Ha dois "Ver tudo": o do topo (tablet e desktop) e o de baixo dos cards
    // (mobile). Os dois seguem a colecao da aba ativa.
    syncHeader() {
      const tab = this.tabs && this.tabs.currentTab;
      if (tab && tab.dataset.url) {
        this.querySelectorAll("[data-carousel-view-all]").forEach((link) => {
          link.href = tab.dataset.url;
        });
      }
      this.syncArrows();
    }

    syncArrows() {
      this.headerActions && this.headerActions.sync();
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (target) => {
        this.syncNotes(target && target.dataset.index);
        const tabId = target.getAttribute("href");
        const slider = this.querySelector(tabId + " .swiper-container");
        const controlsContainer = this.querySelector(
          tabId + " .m-slider-controls",
        );
        // trigger update slider
        slider && slider.swiper && slider.swiper.update();
        this.syncHeader();
        const firstItem =
          slider &&
          (slider.querySelector(".m-image") ||
            slider.querySelector(".m-placeholder-svg"));
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty(
            "--offset-top",
            parseInt(itemHeight) / 2 + "px",
          );
        }
      });
    }

    initSliderByScreenSize(sliderContainer) {
      const mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      const slider = sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer =
        sliderContainer.querySelector(".m-slider-controls");

      if (MinimogTheme.config.mqlMobile && mobileDisableSlider) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        slider.classList.remove("swiper-container");
        if (slider.swiper) slider.swiper.destroy(false, true);
      } else {
        controlsContainer && controlsContainer.classList.remove("m:hidden");
        setTimeout(() => {
          this.initSlider(sliderContainer);
        });
      }
    }

    initSlider(sliderContainer) {
      const layoutWrapper = sliderContainer.querySelector(".m-product-list");
      const swiper =
        sliderContainer &&
        sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer =
        sliderContainer.querySelector(".m-slider-controls");
      const prevButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength =
        sliderContainer &&
        sliderContainer.querySelector(".swiper-wrapper") &&
        sliderContainer.querySelector(".swiper-wrapper").childElementCount;
      // "Cabe tudo sem carrossel" e uma conta de DESKTOP: `items` e o
      // "Products per row" do editor. No mobile entra pouco mais de um card por
      // tela (o slide tem largura fixa, ver product-tabs.css), entao mesmo uma
      // aba com 3 produtos precisa deslizar — e a mesma leitura da secao New
      // collection, que nunca troca o carrossel por grade.
      if (
        !MinimogTheme.config.mqlMobile &&
        parseInt(this.items) >= slideItemsLength
      ) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        layoutWrapper.classList.add("m-mixed-layout--mobile-grid");
        this.syncArrows();
        return;
      }
      // ao voltar do desktop para o mobile a grade acima ficaria marcada
      layoutWrapper.classList.remove("m-mixed-layout--mobile-grid");

      swiper && swiper.classList.add("swiper-container");

      // Figma 77:130 / 77:246 — o carrossel mantem um card de largura fixa em
      // qualquer viewport e sangra pela direita, em vez de encaixar um numero
      // inteiro de cards. "auto" faz o Swiper ler a largura do slide definida
      // em product-tabs.css; um valor numerico esticaria o card ate a borda.
      let slider = new MinimogLibs.Swiper(swiper, {
        slidesPerView: "auto",
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        // sem loop: o carrossel tem comeco e fim, e as setas do topo apagam
        // nas pontas (mesmo comportamento de "Products to show" como teto)
        loop: false,
        pagination: this.showPagination
          ? {
              el: sliderContainer.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: "auto",
          },
          992: {
            slidesPerView: "auto",
          },
          1280: {
            slidesPerView: "auto",
          },
        },
        threshold: 2,
        on: {
          progress: () => this.syncArrows(),
          resize: () => this.syncArrows(),
          init: function () {
            setTimeout(() => {
              MinimogTheme.syncSliderControlsOffset(
                sliderContainer,
                controlsContainer,
              );
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              // com slidesPerView "auto" nao ha numero para comparar; o Swiper
              // decide quantos cabem, entao trata como 0 e mantem as setas
              const visibleSlides =
                typeof slidesPerView === "number" ? slidesPerView : 0;
              if (slideItemsLength > visibleSlides) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      this.syncArrows();

      if (slider && this.showNavigation) {
        prevButton &&
          prevButton.addEventListener("click", () => slider.slidePrev());
        nextButton &&
          nextButton.addEventListener("click", () => slider.slideNext());
      }
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
        this.syncNotes(this.select.value);
        const slider =
          this.tabs &&
          this.tabs.currentTab &&
          this.tabs.currentTab.querySelector(".swiper-container");
        const controlsContainer =
          this.tabs &&
          this.tabs.currentTab &&
          this.tabs.currentTab.querySelector(".m-slider-controls");
        const prevButton =
          controlsContainer &&
          controlsContainer.querySelector(".m-slider-controls__button-prev");
        const nextButton =
          controlsContainer &&
          controlsContainer.querySelector(".m-slider-controls__button-next");
        slider && slider.swiper && slider.swiper.update();
        this.syncHeader();
        const firstItem = slider && slider.querySelector(".m-image");
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty(
            "--offset-top",
            parseInt(itemHeight) / 2 + "px",
          );

          prevButton.classList.remove("m:hidden");
          nextButton.classList.remove("m:hidden");
        }
      });
    }

    initLoadMore(wrapper) {
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(
        this.selectors.productsContainer,
      );

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(
          `#${tabId} ${this.selectors.productsContainer}`,
        );

        if (products) {
          Array.from(products.childNodes).forEach((product) =>
            productsContainer.appendChild(product),
          );
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("m-spinner-loading");
      } else {
        loadBtn.classList.remove("m-spinner-loading");
      }
    }
  }
  customElements.define("m-product-tabs", MProductTabs);
}
